import { injectable } from "tsyringe";
import { Logger } from "../../utils/Logger";
import { Coordinates, GeoCoordinatesService } from "./GeoCoordinatesService";

/**
 * This implementation of the GeoCoordinatesService uses the GeoIp functions provided by the front end of the website.
 */
@injectable()
export class GeoIpCoordinatesService implements GeoCoordinatesService {
  public getCoordinates(): Coordinates | undefined {
    const latFunc = window.geoip_latitude;
    const lonFunc = window.geoip_longitude;

    if (!latFunc || !lonFunc) {
      Logger.warn("GeoIp functions are not available");
      return undefined;
    }

    const latitude = latFunc();
    const longitude = lonFunc();
    if (!latitude || !longitude) {
      Logger.warn("Latitude and / or longitude are not available");
      return undefined;
    }
    return new Coordinates(latitude, longitude);
  }
}
